<div class="flex items-center gap-2 @container">
  <div class="ml-auto flex items-center gap-3">
    <span class="hidden @sm:block">Items per Page:</span>
    <select
      class="hidden w-fit pr-8 @sm:block"
      [(ngModel)]="selectedPageSize"
      (ngModelChange)="setPageSize()"
    >
      @for (pageSize of pageSizes; track pageSize) {
        <option [value]="pageSize">
          @if (pageSize === 0 && zeroPageSizeLabel) {
            {{ zeroPageSizeLabel }}
          } @else {
            {{ pageSize }}
          }
        </option>
      }
    </select>
    <p>
      {{ pagingService?.firstItem }} - {{ pagingService?.lastItem }}
      @if (showTotal) {
        of {{ pagingService?.totalItems }}
      }
    </p>
  </div>
  <p-button
    size="small"
    severity="contrast"
    variant="text"
    (click)="previousPage()"
    [disabled]="!pagingService?.hasPrevPage"
    pTooltip="Previous"
    tooltipPosition="left"
  >
    <ng-template #icon>
      <svg-icon src="/assets/icons/general/chevron-left.svg" />
    </ng-template>
  </p-button>

  <p-button
    size="small"
    severity="contrast"
    variant="text"
    (click)="nextPage()"
    [disabled]="!pagingService?.hasNextPage"
    pTooltip="Next"
    tooltipPosition="left"
  >
    <ng-template #icon>
      <svg-icon src="/assets/icons/general/chevron-right.svg" />
    </ng-template>
  </p-button>
</div>
